import { render } from "./RestaurantView.vue?vue&type=template&id=429edc3c"
import script from "./RestaurantView.vue?vue&type=script&lang=js"
export * from "./RestaurantView.vue?vue&type=script&lang=js"

import exportComponent from "/srv/guestwaiterreportingfront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__